"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closePlaceItemsShorthand = exports.openPlaceItemsShorthand = void 0;
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var getPlaceItemsShorthandParts = function () {
    return [
        {
            prop: 'align-items',
            dataType: css_data_types_1.alignItemsDataType,
            beforeOpenerCheck: (0, shorthand_parser_utils_1.intersectionBeforeOpenerCheck)('place-items', [css_data_types_1.alignItemsDataType, css_data_types_1.justifyItemsDataType]),
            partOpener: (0, shorthand_parser_utils_1.splitSimpleShorthandOpener)(['align-items', 'justify-items']),
        },
        {
            prop: 'justify-items',
            dataType: css_data_types_1.justifyItemsDataType,
            beforeOpenerCheck: (0, shorthand_parser_utils_1.intersectionBeforeOpenerCheck)('place-items', [css_data_types_1.alignItemsDataType, css_data_types_1.justifyItemsDataType]),
        },
    ];
};
// place-items
var openPlaceItemsShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'place-items',
        parts: getPlaceItemsShorthandParts(),
        shorthandOpener: function (astNodes, api, parts) { return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts)(astNodes, api); },
    });
};
exports.openPlaceItemsShorthand = openPlaceItemsShorthand;
var closePlaceItemsShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.createShorthandCloserTemplateFromParts)(getPlaceItemsShorthandParts()));
};
exports.closePlaceItemsShorthand = closePlaceItemsShorthand;
//# sourceMappingURL=place-items-shorthand.js.map